import { c as _c } from "react/compiler-runtime";
import { DataFileInterface } from '@systemeio/file-manager';
import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export type ResourceFileType = Pick<DataFileInterface, 'id' | 'name' | 'filename' | 'path' | 'thumbnail'>;
export const useResourceFiles = digitalProductId => {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: listFetcher
  } = useFetch(t0);
  const isFetchAllowed = !!user && !!digitalProductId;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      revalidateOnMount: true
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useControlledSwr(`/api/dashboard/customer/all-data-files-by-digital-product/${digitalProductId}?order=next`, listFetcher, t1, isFetchAllowed);
};